module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-square-quote-647fef3c.svg";